var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.084 42.321-16.6-6.348c.632-3.351 4.754-7.62 11.307-5.111 6.553 2.508 7.009 8.386 5.293 11.46Z",
    fill: "#31B59F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.89 3.73c-1.639 2.714-4.42 7.657-.437 14.567 3.911 6.786 2.164 6.654-2.595 8.344-4.759 1.69-7.949 3.982-9.925 10.935m23.222 8.89c3.154-6.384 2.399-10.831-.506-15.22-3.234-4.884-2.088-5.548 3.536-7.692 5.363-2.044 7.874-3.211 9.552-11.077",
    stroke: "#35404A",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.06 13.073-23.688-9.07a1.654 1.654 0 0 1 1.183-3.09l23.689 9.07a1.654 1.654 0 0 1-1.183 3.09ZM32.358 49.053l-23.69-9.07a1.654 1.654 0 0 1 1.184-3.09l23.689 9.07a1.654 1.654 0 0 1-1.183 3.09Z",
    stroke: "#35404A",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.053 21.889c-.396-2.39-2.661-4.979-3.236-7.224 3.88-.87 6.306 1.338 8.566 2.939 1.195.868 2.121 2.458 6.62 1.672-2.169 1.806-5.253 1.78-8.13 3.559-1.845 1.14-2.662 2.808-3.143 2.624-.481-.185-.354-1.622-.677-3.57Z",
    fill: "#31B59F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.008,
    cy: 27.253,
    r: 0.688,
    transform: "rotate(20.948 27.008 27.253)",
    fill: "#31B59F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.236,
    cy: 29.39,
    r: 0.688,
    transform: "rotate(20.948 26.236 29.39)",
    fill: "#31B59F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.482 36.373-2.261-.815M3.256 40.731l-2.201.965M6.088 32.87l-1.08-2.147",
    stroke: "#31B59F",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h50v50H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.40b40706e46ea47c86bc39f55991f8bc.svg";
export { ForwardRef as ReactComponent };